import { useMutation } from 'react-query';
import axios from 'axios';

const bulkUpdateCodeFlags = async (request) => {
  const { data: response } = await axios.post(`${process.env.REACT_APP_API_URL}/admin/code-flags/bulk`, request);
  return response.result;
};

export default function useBulkCodeFlags() {
  return useMutation('BULK_CODE_FLAGS', (request) => bulkUpdateCodeFlags(request));
}
